import { getPrioritizedArticleStatusProduct } from '../../../shared/utils/product/product';

import {
  CLUB_MEMBER_BENEFIT,
  CLUB_MEMBER_CLUB_NAME,
  CLUB_MEMBER_MATCH_CTA,
  PDP_MULTISTORE_NEARBY_DISTANCE,
  PDP_MULTISTORE_SELECTED_STORE_TYPE,
  PRODUCT_ALTERNATE_STOCK_STATUS,
  PRODUCT_STOCK_LEVEL,
  PRODUCT_STOCK_LEVEL_IS_FROM_MY_STORE,
  PRODUCT_STOCK_LEVEL_STORE_CODE
} from '../../../shared/constants/data-layer';
import { CLUB_MEMBERSHIP_SIGN_IN_MESSAGE } from '../../../shared/constants/messages';

export function getPdpClubPromotionDataLayerValues(showSignIn, clubPromotion) {
  if (process.env.__FF_CLUB_MEMBERSHIP_BENEFITS__ === 'true') {
    const clubMemberAnalytics = {
      [CLUB_MEMBER_BENEFIT]: '',
      [CLUB_MEMBER_CLUB_NAME]: '',
      [CLUB_MEMBER_MATCH_CTA]: ''
    };

    if (showSignIn) {
      clubMemberAnalytics[CLUB_MEMBER_MATCH_CTA] =
        CLUB_MEMBERSHIP_SIGN_IN_MESSAGE;
    } else {
      clubMemberAnalytics[CLUB_MEMBER_BENEFIT] =
        clubPromotion?.description || '';
      clubMemberAnalytics[CLUB_MEMBER_CLUB_NAME] =
        clubPromotion?.promotionConditionType || '';
    }

    return clubMemberAnalytics;
  } else {
    return {};
  }
}

export function getPdpMultiStoreDataLayerValues(
  product,
  nearByStores,
  myStoreCode,
  selectedStoreCode
) {
  const articleStatusProduct = getPrioritizedArticleStatusProduct(
    product,
    product?.rearProduct
  );
  const productStockStatus =
    myStoreCode !== selectedStoreCode
      ? [articleStatusProduct?.nearByStoreStock?.availabilityMessage]
      : [product?.stock?.availabilityMessage];
  const storeCode =
    myStoreCode !== selectedStoreCode ? selectedStoreCode : myStoreCode;

  const productAlternateStockStatus =
    myStoreCode === selectedStoreCode
      ? [articleStatusProduct?.nearByStoreStock?.availabilityMessage]
      : [product?.stock?.availabilityMessage];

  const nearByStoreDistance =
    nearByStores
      ?.find(s => s?.code === articleStatusProduct?.nearByStoreStock?.storeCode)
      ?.distance?.toString() || '';
  const selectedMultiStoreType =
    myStoreCode === selectedStoreCode ? 'preferred' : 'nearby';
  const productStockIsFromMyStore = selectedStoreCode
    ? [myStoreCode === selectedStoreCode ? '1' : '0']
    : [''];
  return {
    [PDP_MULTISTORE_NEARBY_DISTANCE]: nearByStoreDistance,
    [PDP_MULTISTORE_SELECTED_STORE_TYPE]: selectedMultiStoreType,
    [PRODUCT_ALTERNATE_STOCK_STATUS]: productAlternateStockStatus,
    [PRODUCT_STOCK_LEVEL]: productStockStatus,
    [PRODUCT_STOCK_LEVEL_IS_FROM_MY_STORE]: productStockIsFromMyStore,
    [PRODUCT_STOCK_LEVEL_STORE_CODE]: [storeCode]
  };
}
